import ThemedLayout from 'components/atoms/ThemedLayout'
import i18n from 'utils/i18n'
import ThemedSafeAreaComponentTop from 'components/atoms/ThemedSafeAreaTop'
import React from 'react'
import ThemedBlock from 'components/atoms/ThemedBlock'
import _ from 'lodash'
import { Column, Container, Grid, Row } from 'components/atoms/BootstrapGrid'
import Text from "theme/Text";
import ThemedDivider from 'components/atoms/ThemedDivider'
import MapImage from './assets/map.png'
import { StyleSheet, ImageBackground } from 'react-native'
import TextDivider from 'components/atoms/TextDivider'


const HomeMoreTravelHistoryDetailScene = () => {
	
	const transportItems = [
		{
			name: i18n.t(`basic.transport.kind.bike` ),
			distance: 2.5
		},
		{
			name: i18n.t(`basic.transport.kind.public_transport` ),
			distance: 12
		},
		{
			name: i18n.t(`basic.transport.kind.other` ),
			distance: 1
		},
	];
	
	const renderItem = ( name, value ) => {
		
		return (
			<Row
				align={"flex-start"}>
				
				<Column>
					<Text>{ name }</Text>
				</Column>
				<Column>
					<Text>{ value } km</Text>
				</Column>
			</Row>
		)
	}
	
	let totalDistance = 0;
	const transportList = _.map( transportItems, o => {
		totalDistance += o.distance
		
		return renderItem( o.name, o.distance )
	})
	
	return (
		<ThemedSafeAreaComponentTop top={false}>
			<ThemedLayout
				topNavigation={ true }
				showBackButton={ true }
				footerBar={ true }
				title={ i18n.t( 'titles.more_travel_history') }>
				
				<TextDivider
					rowStyle={ staticStyles.textDividerMarginTop12 }
					text={ 'Distance' }
				/>
				<ThemedBlock shadow mediumPadding>
					<Grid>
						<Container>
							{ transportList }
							
							<ThemedDivider />
							{ renderItem( 'Totaal', totalDistance ) }
						</Container>
					</Grid>
				</ThemedBlock>
				
				<TextDivider
					rowStyle={ staticStyles.textDividerMarginTop12 }
					text={ 'Map' }
				/>
				<ThemedBlock shadow>
					<ImageBackground
						resizeMode={ 'cover' }
						source={ MapImage }
						style={ staticStyles.imageBackgroundWidth100Height350 }
					/>
				</ThemedBlock>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

const staticStyles = StyleSheet.create({
	textDividerMarginTop12: {
		marginTop: 12,
	},
	imageBackgroundWidth100Height350: {
		width: '100%',
		height: 350,
	},
});

export default HomeMoreTravelHistoryDetailScene
